import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

/**
 * Compact inline row of single-select filter chips. When `allowClear` is set,
 * clicking the active chip deselects it (value -> null).
 */
function FilterChipRow({ options = [], value, onSelect, allowClear = false }) {
  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <Chip
            key={option.value}
            label={option.label}
            size="small"
            color={selected ? "primary" : "default"}
            variant={selected ? "filled" : "outlined"}
            onClick={() => onSelect(selected && allowClear ? null : option.value)}
            sx={{ fontWeight: selected ? 600 : 400 }}
          />
        );
      })}
    </Box>
  );
}

export default FilterChipRow;
